import React, { useEffect, useState } from 'react';
import { businessInfo } from '../data/mock';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactFormDialog from '../components/ContactFormDialog';

const Terms = () => {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  useEffect(() => {
    // Set meta title
    document.title = 'Terms & Conditions | Trademark Restaurant Name';
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Terms and Conditions for using Trademark Restaurant Name trademark registration services. Read about our service agreements, fees, and legal terms.';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onContactClick={() => setIsContactDialogOpen(true)} />
      
      {/* Content */}
      <div className="container mx-auto px-4 py-32">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-[#1e3a5f] mb-8">Terms & Conditions</h1>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Agreement to Terms</h2>
              <p className="leading-relaxed">
                By accessing or using the services of {businessInfo.name}, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Services Description</h2>
              <p className="leading-relaxed mb-3">
                We provide trademark registration services including but not limited to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Trademark search and clearance analysis</li>
                <li>Trademark application preparation and filing</li>
                <li>Office action responses and legal representation</li>
                <li>Trademark monitoring and maintenance services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Attorney-Client Relationship</h2>
              <p className="leading-relaxed">
                An attorney-client relationship is established only when you formally engage our services and we accept your case in writing. Initial consultations and general information provided on our website do not constitute legal advice or create an attorney-client relationship.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Fees and Payment</h2>
              <p className="leading-relaxed mb-3">
                Service fees are as stated on our website or in your engagement agreement. All fees are subject to the following terms:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service fees are separate from government filing fees</li>
                <li>USPTO filing fees are subject to change and are non-refundable</li>
                <li>Payment is required before filing your trademark application</li>
                <li>Additional fees may apply for office action responses or complex matters</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">No Guarantee of Results</h2>
              <p className="leading-relaxed">
                While we strive for the highest success rate, we cannot guarantee that the USPTO will approve your trademark application. Approval depends on many factors including trademark availability, distinctiveness, and USPTO examination standards. Rejection by the USPTO does not entitle you to a refund of service fees already paid.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Client Responsibilities</h2>
              <p className="leading-relaxed mb-3">As a client, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Respond promptly to our requests for information</li>
                <li>Review all documents before submission</li>
                <li>Comply with USPTO requirements and deadlines</li>
                <li>Notify us of any changes to your contact information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Intellectual Property</h2>
              <p className="leading-relaxed">
                All content on our website, including text, graphics, logos, and images, is the property of {businessInfo.name} and protected by copyright and trademark laws. You may not use our content without prior written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Limitation of Liability</h2>
              <p className="leading-relaxed">
                To the fullest extent permitted by law, {businessInfo.name} shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services or inability to use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Dispute Resolution</h2>
              <p className="leading-relaxed">
                Any disputes arising from these Terms or our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. The arbitration shall take place in Santa Monica, California.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Contact Information</h2>
              <p className="leading-relaxed mb-3">
                For questions about these Terms and Conditions, please contact us:
              </p>
              <ul className="space-y-2">
                <li>Email: {businessInfo.email}</li>
                <li>Phone: {businessInfo.phone}</li>
                <li>Address: {businessInfo.address}</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      
      <ContactFormDialog
        open={isContactDialogOpen}
        onOpenChange={setIsContactDialogOpen}
      />
      
      <Footer />
    </div>
  );
};

export default Terms;
